import { ObjectValues } from "./generic";

type Module<T extends AccountModuleName | UserModuleName> = {
  Name: T;
  Title: string;
  Description?: string;
};

/**
 * All available account modules
 */
export const AccountModuleName = {
  AddressExport: "address_export",
  AttachmentsBulkImport: "attachments_bulk_import",
  CollaborationCTS: "collaboration_cost_to_serve",
  CollaborationCTSBomCarve: "collaboration_cost_to_serve_bom_carve",
  DesignProject: "design_project",
  DualSided: "dual_sided",
  FlexNap: "flexnap",
  ImportReport: "financial_analytics_report_import",
  NBNDesign: "nbn_design",
  Overlays: "overlays",
  ParcelExport: "parcel_export",
  SpliceTables: "splice_tables",
  PlannerExtended: "planner_extended",
  ISGDesign: "isg_design",
  MuPower: "mu_power",
} as const;
export type AccountModuleName = ObjectValues<typeof AccountModuleName>;
export type AccountModule = Module<AccountModuleName>;

/**
 * All available user modules
 */
export const UserModuleName = {
  FondAdmin: "fond_admin",
} as const;
export type UserModuleName = ObjectValues<typeof UserModuleName>;
export type UserModule = Module<UserModuleName>;
